import React from 'react'
export const AnimatedLoader = (
    <div className="d-flex-center" style={{ width: '100vw', height: '100vh' }}>
        <div className="">
            <div className="ball-grid-pulse">
                <div style={{ backgroundColor: 'rgb(102, 194, 42)' }} />
                <div style={{ backgroundColor: 'rgb(102, 194, 42)' }} />
                <div style={{ backgroundColor: 'rgb(102, 194, 42)' }} />
                <div style={{ backgroundColor: 'rgb(102, 194, 42)' }} />
                <div style={{ backgroundColor: 'rgb(102, 194, 42)' }} />
                <div style={{ backgroundColor: 'rgb(102, 194, 42)' }} />
                <div style={{ backgroundColor: 'rgb(102, 194, 42)' }} />
                <div style={{ backgroundColor: 'rgb(102, 194, 42)' }} />
                <div style={{ backgroundColor: 'rgb(102, 194, 42)' }} />
            </div>
        </div>
    </div>
)
